import { render, staticRenderFns } from "./SettlementDetailsModal.vue?vue&type=template&id=5fe0a246&scoped=true"
import script from "./SettlementDetailsModal.vue?vue&type=script&lang=js"
export * from "./SettlementDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetailsModal.vue?vue&type=style&index=0&id=5fe0a246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0a246",
  null
  
)

export default component.exports